(function() {
    'use strict';

    angular.module('GorillaBoy')
    .constant('moveModalState', {
        IDLE: 'IDLE',
        LOADING: 'LOADING',
        FINISHED: 'FINISHED',
        ERROR: 'ERROR'
    })
    .controller('moveModalCtrl', [
        '$scope',
        '$timeout',
        '$translate',
        '$http',
        '$log',
        '$q',
        '$uibModalInstance',
        'EndpointService',
        'moveModalState',
        'FileService',
        'SortService',
        'authenticatedUser',
        'MessageProvider',
        'MessageManager',
        'AppConstants',
        'sources',
        'isRecovering',
        moveModalCtrl
    ]);

    function moveModalCtrl($scope, $timeout, $translate, $http, $log, $q, $uibModalInstance, EndpointService, moveModalState, fileService, SortService, authenticatedUser, MessageProvider, MessageManager, AppConstants, sources, isRecovering) {
        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods,
            MAX_FILENAME_LENGTH = 14;

        activate();

        function activate() {
            $scope.destinationFolderNameAndId = null;
            $scope.folderInfoArray = [];
            $scope.sources = sources;
            $scope.sourceFolderIdSet = {};

            if(isRecovering){
              $scope.labels = {
                title: 'MODAL.MOVE_RECOVERY_MODAL.TITLE',
                mainMessage: 'MODAL.MOVE_RECOVERY_MODAL.RECOVER_FILE',
                okButton: 'MODAL.MOVE_RECOVERY_MODAL.RECOVER'
              };
            } else {
              $scope.labels = {
                title: 'MODAL.MOVE_MODAL.TITLE',
                mainMessage: 'MODAL.MOVE_MODAL.MOVE_FILE',
                okButton: 'FILE_ACTIONS.MOVE'
              };
            }

            $scope.hideModal = function() {
                $uibModalInstance.dismiss();
            };

            $scope.truncate = function(name) {
                if (name) {
                    return name.length <= MAX_FILENAME_LENGTH ? name : name.substring(0, MAX_FILENAME_LENGTH) + ' ...';
                }
                return name;
            };

            $scope.pushFolder = function(id, name) {
                // 1. Push the folder info with an empty subfolders array to update the UI.
                var newFolderInfo = {
                    id: id,
                    folderName: name,
                    subfolders: [],
                    state: moveModalState.LOADING
                };

                $scope.folderInfoArray.push(newFolderInfo);

                // 2. Then, load all subfolders from the service.
                getSubfolders(id, function successCB(subfolders) {
                    newFolderInfo.state = moveModalState.FINISHED;
                    newFolderInfo.subfolders = subfolders;
                }, function failureCB(error) {
                    newFolderInfo.state = moveModalState.ERROR;
                });

                // 3. Update the selected folder.
                $scope.updateSelectedFolder(id, name);
            };

            $scope.gotoFolderId = function(id) {
                var foundFolder = null;
                var foundFolderIndex = 0;

                // Find the folder that matches the given folder ID.
                var folderLength = $scope.folderInfoArray.length;
                for (;foundFolderIndex < folderLength; foundFolderIndex++) {
                    foundFolder = $scope.folderInfoArray[foundFolderIndex];
                    if (foundFolder.id === id) {
                        break;
                    }
                }

                // Update folderInInfoArray.
                $scope.folderInfoArray = $scope.folderInfoArray.slice(0, foundFolderIndex + 1);

                // Update selected folder.
                $scope.updateSelectedFolder(foundFolder.id, foundFolder.folderName);

            };

            $scope.getCurrentFolderName = function() {
                return $scope.folderInfoArray.length > 0 ? $scope.folderInfoArray[$scope.folderInfoArray.length - 1].folderName : "";
            };

            $scope.gotoParentFolder = function() {
                if ($scope.folderInfoArray.length > 1) {
                    var previousFolder = $scope.folderInfoArray[$scope.folderInfoArray.length - 2];
                    $scope.gotoFolderId(previousFolder.id);
                }
            };

            $scope.updateSelectedFolder = function(selectedFolderId, selectedFolderName) {
                if (selectedFolderId === 'webClientSharedWithMe' || selectedFolderId === 'webClientHome') {
                    return;
                }
                if ($scope.destinationFolderNameAndId === null ||
                    $scope.destinationFolderNameAndId.id !== selectedFolderId) {
                    $scope.destinationFolderNameAndId = {
                        id: selectedFolderId,
                        name: selectedFolderName
                    };
                }
            };

            $scope.clickMoveButton = function() {
                performMove(function completionCB(successSources, failureSources, savedDestFolderNameAndId) {
                    showMessage(successSources, failureSources, savedDestFolderNameAndId);

                    var hasAnySuccess = !!successSources && (successSources.docs.length > 0 || successSources.folders.length > 0);

                    $uibModalInstance.close(hasAnySuccess);
                });
            };

            $scope.clickBackButton = function() {
                if ($scope.folderInfoArray.length > 1) {
                    $scope.folderInfoArray.pop();

                    var folderInfo = $scope.folderInfoArray[$scope.folderInfoArray.length - 1];
                    $scope.updateSelectedFolder(folderInfo.id, folderInfo.folderName);
                }
            };

            $scope.sourceFileNames = function() {
                var result = "";

                // Combine all file names.
                angular.forEach($scope.sources.docs, function(docNameAndId, i) {
                    result = result.concat(", ", docNameAndId.name);
                });

                // Combine all folder names.
                angular.forEach($scope.sources.folders, function(folderNameAndId, i) {
                    result = result.concat(", ", folderNameAndId.name);
                });

                return result.length > 0 ? result.substring(2) : result;
            };

            //execute below

            angular.forEach(sources.folders, function(folderNameAndId, i) {
                $scope.sourceFolderIdSet[folderNameAndId.id] = true;
            });

            $timeout(function() {
                var homeFolderInfo = {
                    id: 'webClientHome',
                    folderName: $translate.instant('GENERAL_LABELS.HOME'),
                    subfolders: [{
                        Id: authenticatedUser.getUserInfo().RootFolderId,
                        Name: $translate.instant('MODAL.MOVE_MODAL.MY_DOCUMENTS')
                    }, {
                        Id: "webClientSharedWithMe",
                        Name: $translate.instant('LEFT_NAV.SHARED_WITH_ME')
                    }],
                    state: moveModalState.FINISHED
                };
                $scope.folderInfoArray.push(homeFolderInfo);
            }, 100);

        }

        function getSubfolders(id, successCB, failureCB) {
            var subfolders = [];

            // Pagination:
            // Recursively call this function until the marker returned from the service is null.
            function fetchFolder(id, marker) {
                var params = {
                    sortBy: 'NAME',
                    order: SortService.CONSTANTS.ORDER.ASCENDING,
                    marker: marker
                };

                fileService.getFolder(id, params).then(function(folderResult) {
                    var foldersInResponse = folderResult.Folder.Folders;
                    subfolders = subfolders.concat(foldersInResponse || []);

                    // If the marker exists, load more by calling
                    // fileService#GetFolder function recursively.
                    var marker = folderResult.Marker || null;

                    // If there exists one or more documents, stop loading more.
                    // The getFolder pagination call returns all folders first and then documents.
                    var hasDocument = false;
                    var documentsInResponse = folderResult.Folder.Documents;
                    if (!!documentsInResponse && documentsInResponse.length > 0) {
                        hasDocument = true;
                    }

                    if (marker && !hasDocument) {
                        fetchFolder(id, marker);
                    } else {
                        successCB(subfolders);
                    }
                }, function(error) {
                    failureCB(error);
                });
            }

            if (id === 'webClientSharedWithMe') {
                fileService.getSharedWithMeRoot()
                    .then(function(result) {
                        $log.debug("Fetched shared with me content");
                        successCB(result.Folders);
                    }, failureCB);
            } else {
                fetchFolder(id);
            }

        }

        // Move the source folders and documents into the destination folder.
        // The given completionCB is called after moving all folders and documents
        // or failing to move one or multiple folders and documents.
        function performMove(completionCB) {
            if (!$scope.sources || !$scope.destinationFolderNameAndId) {
                throw 'sources and destinationFolderNameAndId must not be null.';
            }

            function createConfig(isFolder, srcId, destFolderId) {
                var typeLocation = isFolder ? 'folders/' : 'documents/';

                return {
                    url: EndpointService.endpoint(true) + typeLocation + srcId,
                    method: httpMethods.PATCH,
                    data: {
                        ParentFolderId: destFolderId
                    }
                };
            }

            function createRecoverConfig(srcId, destFolderId){
                var typeLocation = 'recover/';

                return {
                  url: EndpointService.endpoint(true) + typeLocation + srcId +"?recoveryDestination=" + encodeURIComponent(destFolderId),
                  method: httpMethods.GET
                };
            }

            // Call completionCB when successOrFailureCount reaches totalNum.
            // TODO (simmkyu): once the API supports batch move, switch to a single call.
            var totalNum = $scope.sources.docs.length + $scope.sources.folders.length;
            var successOrFailureCount = 0;
            var successSources = {
                docs: [],
                folders: []
            };
            var failureSources = {
                docs: [],
                folders: []
            };

            // Save the destination folder name and ID, which will be passed to
            // completionCB once all folders and documents are moved.
            // This is required since a new move modal can be opened before a previous
            // move request is completed.
            var savedDestFolderNameAndId = $scope.destinationFolderNameAndId;

            function updateSuccessOrFailureCount() {
                successOrFailureCount += 1;
                if (successOrFailureCount === totalNum) {
                    completionCB(
                        (successSources.docs.length === 0 && successSources.folders.length === 0) ? null : successSources, (failureSources.docs.length === 0 &&
                            failureSources.folders.length === 0) ? null : failureSources,
                        savedDestFolderNameAndId
                    );
                }
            }

            function performMoveRequest(isFolder, sourceNameAndId, config) {
                $http(EndpointService.tokenize(config))
                .success(function(res) {
                    if (isFolder) {
                        successSources.folders.push(sourceNameAndId);
                    } else {
                        successSources.docs.push(sourceNameAndId);
                    }

                    updateSuccessOrFailureCount();
                })
                .error(function(res) {
                    var sourceNameAndIdWithResponse = {
                        id: sourceNameAndId.id,
                        name: sourceNameAndId.name,
                        response: res
                    };

                    if (isFolder) {
                        failureSources.folders.push(sourceNameAndIdWithResponse);
                    } else {
                        failureSources.docs.push(sourceNameAndIdWithResponse);
                    }

                    updateSuccessOrFailureCount();
                });
            }

            // Move all documents.
            angular.forEach($scope.sources.docs, function(docNameAndId, i) {
                var config = (isRecovering)? createRecoverConfig(docNameAndId.id, $scope.destinationFolderNameAndId.id)
                              : createConfig(false, docNameAndId.id, $scope.destinationFolderNameAndId.id);
                performMoveRequest(false, docNameAndId, config);
            });

            // Move all folders.
            angular.forEach($scope.sources.folders, function(folderNameAndId, i) {
                var config = (isRecovering)? createRecoverConfig(folderNameAndId.id, $scope.destinationFolderNameAndId.id)
                              : createConfig(true, folderNameAndId.id, $scope.destinationFolderNameAndId.id);
                performMoveRequest(true, folderNameAndId, config);
            });
        }

        // Return "documents and folders", "documents", or "folder".
        function generateTypeName(sources) {
            var typeName;
            if (sources.docs.length > 0 && sources.folders.length > 0) {
                typeName = MessageProvider.moveModalTypeNameFoldersAndDocuments;
            } else if (sources.docs.length > 0) {
                typeName = MessageProvider.moveModalTypeNameDocuments;
            } else {
                typeName = MessageProvider.moveModalTypeNameFolders;
            }
            return typeName;
        }

        function showMessage(successSources, failureSources, savedDestFolderNameAndId) {
            var message, typeName, response, docName, folderName;
            var totalNumSuccess = (!!successSources) ? successSources.docs.length + successSources.folders.length : 0;
            var totalNumFailure = (!!failureSources) ? failureSources.docs.length + failureSources.folders.length : 0;

            if (!!failureSources) {
                // At this point, there is at least one folder or document failed to be moved.
                // Regardless of # success, always show an error message.
                typeName = generateTypeName(failureSources);

                if (totalNumFailure > 1) {
                    if (totalNumSuccess === 0) {
                        message = MessageProvider.moveModalAllFolderAndDocFailureMessage(typeName);
                    } else {
                        message = MessageProvider.moveModalSomeFolderAndDocFailureMessage(typeName);
                    }
                } else if (failureSources.docs.length === 1) {
                    docName = failureSources.docs[0].name;
                    response = failureSources.docs[0].response;

                    if (!!response.Message && response.Message.indexOf('EntityAlreadyExistsException') >= 0) {
                        message = MessageProvider.moveModalSingleFolderOrDocFailureDuplicateMessage(docName, savedDestFolderNameAndId.name);
                    } else {
                        message = MessageProvider.moveModalSingleFolderOrDocFailureDefaultMessage(docName, savedDestFolderNameAndId.name);
                    }
                } else if (failureSources.folders.length === 1) {
                    folderName = failureSources.folders[0].name;
                    response = failureSources.folders[0].response;

                    if (!!response.Message && response.Message.indexOf('EntityAlreadyExistsException') >= 0) {
                        message = MessageProvider.moveModalSingleFolderOrDocFailureDuplicateMessage(folderName, savedDestFolderNameAndId.name);
                    } else {
                        message = MessageProvider.moveModalSingleFolderOrDocFailureDefaultMessage(folderName, savedDestFolderNameAndId.name);
                    }
                }

                MessageManager.addErrorMoveMessage(message);
            } else if (!!successSources) {
                // 0 failure at this point
                if (totalNumSuccess > 1) {
                    // Multiple folders and documents
                    typeName = generateTypeName(successSources);

                    message = MessageProvider.moveModalMultipleFolderOrDocSuccessMessage(totalNumSuccess + '', typeName, savedDestFolderNameAndId.name);
                } else if (successSources.docs.length === 1) {
                    docName = successSources.docs[0].name;
                    message = MessageProvider.moveModalSingleFolderOrDocSuccessMessage(docName, savedDestFolderNameAndId.name);
                } else if (successSources.folders.length === 1) {
                    folderName = successSources.folders[0].name;
                    message = MessageProvider.moveModalSingleFolderOrDocSuccessMessage(folderName, savedDestFolderNameAndId.name);
                }

                MessageManager.addSuccessMessage(message);
            }
        }
    }

}());
